'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export function ScrollToTop(): null {
  const pathname = usePathname();

  useEffect(() => {
    // Scroll to top only if there is no anchor link in url
    if (!window.location.hash) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}
